import {
	hideInvitesModal,
	hideLeagueRolloverModal,
	hideWelcomeModal,
	showInvitesModal,
	showLeagueRolloverModal,
	showAuthenticationModal,
	hideAuthenticationModal,
	showNextSeasonModal,
	hideNextSeasonModal,
	showTournamentModal,
	hideTournamentModal,
	hideBoostersModal,
	showBoostersModal,
	showAutoSwapModal,
	hideAutoSwapModal,
	showAutoSubModal,
	hideAutoSubModal,
} from "modules/actions/modals";
import {createReducer} from "redux-act";
import {Storage} from "modules/utils";
import {SHOW_INITIAL_MODAL} from "modules/constants";
import {
	IAutoSub,
	IAutoSwap,
	showAcceptTermsModal,
	userAcceptTermsFailed,
	userAcceptTermsSuccess,
} from "modules/actions";

const defaultState = {
	inviteSuccessModal: {
		isShow: false,
		error: "",
		success: false,
	},
	genericModal: {
		isShow: false,
	},
	welcomeModal: {
		isShow: JSON.parse(Storage.GET(SHOW_INITIAL_MODAL) || "true") as boolean,
	},
	termsModal: {
		isShow: false,
	},
	termsNextSeason: {
		isShow: false,
	},
	leagueRolloverModal: {
		isShow: false,
	},
	authenticationModal: {
		isShow: false,
	},
	tournamentModal: {
		isShow: false,
		tileId: 0,
	},
	boostersModal: {
		isShow: false,
	},
	autoSwapModal: {
		isShow: false,
		swap: null,
	},
	autoSubModal: {
		isShow: false,
		sub: null,
	},
};

export interface IModalsReducer {
	inviteSuccessModal: {
		isShow: boolean;
		success: boolean;
		error?: string;
	};
	genericModal: {
		isShow: boolean;
	};
	welcomeModal: {
		isShow: boolean;
	};
	termsModal: {
		isShow: boolean;
	};
	termsNextSeason: {
		isShow: boolean;
	};
	leagueRolloverModal: {
		isShow: boolean;
	};
	authenticationModal: {
		isShow: boolean;
	};
	tournamentModal: {
		isShow: boolean;
		tileId: number;
	};
	boostersModal: {
		isShow: boolean;
	};
	autoSwapModal: {
		isShow: boolean;
		swap: IAutoSwap | null;
	};
	autoSubModal: {
		isShow: boolean;
		sub: IAutoSub | null;
	};
}

const onHideWelcomeModal = (state: IModalsReducer) => ({
	...state,
	welcomeModal: {
		isShow: false,
	},
});

const onHideTermsModal = (state: IModalsReducer) => ({
	...state,
	termsModal: {
		isShow: false,
	},
});

const onShowLeagueRolloverModal = (state: IModalsReducer) => ({
	...state,
	leagueRolloverModal: {
		isShow: true,
	},
});
const onHideLeagueRolloverModal = (state: IModalsReducer) => ({
	...state,
	leagueRolloverModal: {
		isShow: false,
	},
});
const onShowAuthenticationModal = (state: IModalsReducer) => ({
	...state,
	authenticationModal: {
		isShow: true,
	},
});
const onHideAuthenticationModal = (state: IModalsReducer) => ({
	...state,
	authenticationModal: {
		isShow: false,
	},
});

const onShowTournamentModal = (state: IModalsReducer, payload: number) => ({
	...state,
	tournamentModal: {
		isShow: true,
		tileId: payload,
	},
});

const onHideTournamentModal = (state: IModalsReducer) => ({
	...state,
	tournamentModal: {
		isShow: false,
		tileId: 0,
	},
});

const onShowBoostersModal = (state: IModalsReducer) => ({
	...state,
	boostersModal: {
		isShow: true,
	},
});

const onHideBoostersModal = (state: IModalsReducer) => ({
	...state,
	boostersModal: {
		isShow: false,
	},
});

const onShowAutoSwapModal = (state: IModalsReducer, swap: IAutoSwap) => ({
	...state,
	autoSwapModal: {
		isShow: true,
		swap,
	},
});

const onHideAutoSwapModal = (state: IModalsReducer) => ({
	...state,
	autoSwapModal: {
		isShow: false,
		swap: null,
	},
});

const onShowAutoSubModal = (state: IModalsReducer, sub: IAutoSub) => ({
	...state,
	autoSubModal: {
		isShow: true,
		sub,
	},
});

const onHideAutoSubModal = (state: IModalsReducer) => ({
	...state,
	autoSubModal: {
		isShow: false,
		sub: null,
	},
});

export const modals = createReducer<IModalsReducer>({}, defaultState)
	.on(showInvitesModal, (state, payload) => ({
		...state,
		...payload,
		inviteSuccessModal: {
			...state.inviteSuccessModal,
			isShow: true,
			success: payload.success,
		},
	}))
	.on(hideInvitesModal, (state) => ({
		...state,
		inviteSuccessModal: {
			...state.inviteSuccessModal,
			isShow: false,
			success: false,
			error: "",
		},
	}))
	.on(hideWelcomeModal, onHideWelcomeModal)
	.on(showAcceptTermsModal, (state) => ({
		...state,
		termsModal: {isShow: true},
	}))
	.on(showNextSeasonModal, (state) => ({
		...state,
		termsNextSeason: {isShow: true},
	}))
	.on(hideNextSeasonModal, (state) => ({
		...state,
		termsNextSeason: {isShow: false},
	}))
	.on(userAcceptTermsSuccess, onHideTermsModal)
	.on(userAcceptTermsFailed, onHideTermsModal)
	.on(showLeagueRolloverModal, onShowLeagueRolloverModal)
	.on(hideLeagueRolloverModal, onHideLeagueRolloverModal)
	.on(showAuthenticationModal, onShowAuthenticationModal)
	.on(hideAuthenticationModal, onHideAuthenticationModal)
	.on(showTournamentModal, onShowTournamentModal)
	.on(hideTournamentModal, onHideTournamentModal)
	.on(showBoostersModal, onShowBoostersModal)
	.on(hideBoostersModal, onHideBoostersModal)
	.on(showAutoSwapModal, onShowAutoSwapModal)
	.on(hideAutoSwapModal, onHideAutoSwapModal)
	.on(showAutoSubModal, onShowAutoSubModal)
	.on(hideAutoSubModal, onHideAutoSubModal);
